import React from 'react';
import { Chevron } from '../../foundations';
import { textCaption } from '../../styles/typography';
import { classNames } from '../../utils/style';

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  objectClass?: ObjectClass;
  hasFirstChevron?: boolean;
}

export type BreadcrumbItem = {
  node: React.ReactNode;
  separator?: SeparatorType;
  separatorClassName?: string;
  className?: string;
}

export enum SeparatorType {
  BAR = 'bar',
  CHEVRON = 'chevron',
}

type ObjectClass = {
  base?: string;
  list?: string;
  chevron?: string;
  text?: string;
  textActive?: string;
};

const ChevronRight = () => (
  <Chevron className={classNames('w-3.5 h-3.5 inline-block align-middle translate-y-[2px]', 'rotate-[90deg]')} />
);

export const Breadcrumb = ({ items, objectClass, hasFirstChevron }: BreadcrumbProps) => {
  return (
    <nav aria-label="Breadcrumb" className={classNames('Breadcrumb list-none', objectClass?.base)}>
      <ol
        className={classNames(
          textCaption,
          'flex items-center',
          'leading-[150%]',
          objectClass?.list
        )}
      >
        {hasFirstChevron && (
          <span className={classNames("hidden md:block mr-2 align-middle", objectClass?.chevron)} aria-hidden="true">
            <ChevronRight />
          </span>
        )}
        {items.map((item, i) => (
          <li
            key={i}
            className={classNames("inline-flex items-center", i === items.length - 1 ? 'overflow-hidden' : '', item.className)}
            {...(i === items.length - 1 ? { 'aria-current': 'page' } : {})}
          >
            {i !== 0 && item.separator && (
              <span
                className={classNames("mx-2 align-middle", objectClass?.chevron)}
                aria-hidden="true"
              >
                {(() => {
                  switch (item.separator) {
                    case SeparatorType.BAR:
                      return <span className={classNames(item.separatorClassName)}>|</span>;
                    case SeparatorType.CHEVRON:
                      return <span className={classNames("inline-flex items-center", item.separatorClassName)}><ChevronRight /></span>;
                    default:
                      return null;
                  }
                })()}
              </span>
            )}
            <span
              className={classNames(
                i === 0 && 'md:font-bold',
                i === items.length - 1
                  ? objectClass?.text
                  : objectClass?.textActive,
              )}
            >
              {item.node}
            </span>
          </li>
        ))}
      </ol>
    </nav>
  );
};
